/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/14/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Table, Button, Notification, Modal, Select, Grid, Divider, List, Input} from '@scuf/common';
import ExpandablePanel from '../../common/ExpandablePanel'
import {
    CORRECTIVE_ACTION_STATE,
    FAULT_STATES,
    LOG_ACTION_TYPES,
    ACTION_TYPES,
    isClosedState
} from "../common/FaultsConst";
import * as Faults from "../../api/Faults";
import * as Airtime from "../../api/Airtime";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import CloseFaultModal from "../common/CloseFaultModal";
import {verifyAirtimeException} from "../../utils/Helpers";
import {getUIconfigs, UIconfigNames} from "../../api/UIconfig";
import _ from "lodash";
import {EXISTING_ACTION_ID, NEW_ACTION_ID} from "../common/FaultsUtils";
import ActionRow from "./ActionRow";
import Loader from "../../common/Loader";

class Actions extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            expandedRows: [],
            actionLog: [],
            shownAllMax: 10,
            shownTestsMax: 5,
            shownCasMax: 5,
            increaseShownBy: 5,
            allCasNames: [],
            allTestNames: [],
            selectedOtherCaName: null,
            selectedOtherTestName: null,
            notExistingCaComment: '',
            notExistingTestComment: '',
            closeModalOpen: false,
            showCloseWithAction: false,
            detail: {
                description: '',
                references: [],
                changingConfig: false,
                taskTips: [],
                failureModes: [],
            },
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Faults,
            UIConfigIsloaded: false,
            UIconfig_TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED: false,
            UIconfig_ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD: false,
            UIconfig_WE_ARE_SORRY_MESSAGE: false,
            UIconfig_SHOW_CAUSES_IN_CA_ACTION_DETAIL: false,
            loading: false,
        }

        this.toggleRow = this.toggleRow.bind(this)
        this.actionResultSet = this.actionResultSet.bind(this)
        this.fetchAllNamesExceptAllocated = this.fetchAllNamesExceptAllocated.bind(this)
        this.buttonClicked = this.buttonClicked.bind(this)
        this.actionResultSubmitCallback = this.actionResultSubmitCallback.bind(this)
        this.fetchActionsData = this.fetchActionsData.bind(this)
        this.fetchAllNamesExceptAllocated = this.fetchAllNamesExceptAllocated.bind(this)
    }

    componentDidMount() {
        this.fetchActionsData()
        this.fetchAllNamesExceptAllocated(ACTION_TYPES.TEST)
        this.fetchAllNamesExceptAllocated(ACTION_TYPES.CORRECTIVE_ACTION)
        getUIconfigs([
            UIconfigNames.TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED,
            UIconfigNames.ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD,
            UIconfigNames.WE_ARE_SORRY_MESSAGE,
            UIconfigNames.SHOW_CAUSES_IN_CA_ACTION_DETAIL,
        ]).then((response) => {
            const testsAndCas = response.filter(c => c.name === UIconfigNames.TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED);
            const onlyOne = response.filter(c => c.name === UIconfigNames.ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD)
            const sorryMessage = response.filter(c => c.name === UIconfigNames.WE_ARE_SORRY_MESSAGE)
            const showCauses = response.filter(config => config.name === UIconfigNames.SHOW_CAUSES_IN_CA_ACTION_DETAIL)
            this.setState({
                UIconfig_TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED: testsAndCas.length === 0 ? false : testsAndCas[0].status === 'ACTIVE',
                UIconfig_ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD: onlyOne.length === 0 ? false : onlyOne[0].status === 'ACTIVE',
                UIconfig_WE_ARE_SORRY_MESSAGE: sorryMessage.length === 0 ? false : sorryMessage[0].status === 'ACTIVE',
                UIconfig_SHOW_CAUSES_IN_CA_ACTION_DETAIL: showCauses.length === 0 ? false : showCauses[0].status === 'ACTIVE',
                UIConfigIsloaded: true,
            })
            // initially, try to call the method from here (to ensure that UIconfig is loaded)
            // due to racing conditions the method might not be called in componentDidUpdate() method
            // multiple calls to expand first rows do nothing if rows are already expanded
            //this.expandFirstRowAndCollapseOthers();
        })
    }

    expandCondition(prevFault, currentFault) {
        const prevActions = prevFault.actions
        const currentActions = currentFault.actions

        // First expansion
        if (prevActions === null) {
            return currentActions.length !== 0
        }

        // Number of current actions were increased. Do not collapse other rows.
        if (prevActions.length < currentActions.length) {
            return false;
        }

        // Number of current actions were decreased. Expand first row and collapse other rows.
        if (prevActions.length > currentActions.length) {
            return true;
        }

        // Check if test results are the same. If some test result was added or removed do not collapse rows.
        for (const action of currentActions) {
            const pTRForAction = prevActions.find(pa => pa.id === action.id).testResults;
            const cTRForAction = currentActions.find(ca => ca.id === action.id).testResults;
            if (pTRForAction.length !== cTRForAction.length) {
                return false;
            }
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        // expanding the rows (within component update) ensures its expanding
        // when user selects the result and item is moved to done list (or removed from the list)

        // Create new object without "fetchCount". "fetchCount" is always different so for proper comparison must be removed.
        const prevFaultWithoutFetchCount = Object.fromEntries(Object.entries(prevProps.fault).filter(entry => entry[0] !== "fetchCount"));
        const currentFaultWithoutFetchCount = Object.fromEntries(Object.entries(this.props.fault).filter(entry => entry[0] !== "fetchCount"));

        // Compare objects using lodash
        if (this.state.UIConfigIsloaded && !_.isEqual(prevFaultWithoutFetchCount, currentFaultWithoutFetchCount)) {
            // if (this.expandCondition(prevFaultWithoutFetchCount, currentFaultWithoutFetchCount)) {
            //     this.expandFirstRowAndCollapseOthers();
            // }
            if (prevProps.fault.actions !== null && prevProps.fault.actions.length < this.props.fault.actions.length) {
                // New Test was added, open the newly added Test
                const actionIds = prevProps.fault.actions.map(a => a.id);
                const newAction = this.props.fault.actions.filter(action => !actionIds.includes(action.id));
                const key = newAction[0].type + "-" + newAction[0].id;
                this.toggleRow(key);
            }
        }

        if (prevState.selectedOtherCaName !== this.state.selectedOtherCaName && this.state.selectedOtherCaName !== null && this.state.selectedOtherCaName !== NEW_ACTION_ID) {
            this.props.FaultActions.fetchActionDetail(this.props.fault.assetId, this.state.selectedOtherCaName, ACTION_TYPES.CORRECTIVE_ACTION,
                userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY), this.props.faultId).then(
                (response) => {
                    this.setState({detail: response});
                }
            ).then(() => this.setState({loading: false})).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            });
        }
    }

    fetchActionsData() {
        const me = this
        this.props.FaultActions.fetchActions(this.props.fault.assetId, this.props.fault.faultId, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(
            this.state.apiPoint.fetchActionLog(this.props.fault.assetId, this.props.fault.faultId, null, [LOG_ACTION_TYPES.VALUE_SET, LOG_ACTION_TYPES.VALUE_SET_INTERNAL, LOG_ACTION_TYPES.VALUE_SET_LEARNING_LOOP, LOG_ACTION_TYPES.REPORTED], []).then(
                function (response) {
                    me.setState({actionLog: response})
                }
            ).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        ).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    fetchAllNamesExceptAllocated(type) {
        const me = this
        this.state.apiPoint.fetchAllNamesExceptAllocated(this.props.fault.assetId, this.props.fault.faultId, type).then((response) => {
            type === ACTION_TYPES.TEST ? me.setState({allTestNames: response.sort()}) : me.setState({allCasNames: response.sort()});
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    actionResultSet(action, buttonData) {
        const {fault, userProfile} = this.props
        const external = userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)

        if (action.type === ACTION_TYPES.TEST) {
            const testId = action.id === EXISTING_ACTION_ID ? this.state.allTestNames[this.state.selectedOtherTestName].id : action.id
            this.props.FaultActions.submitTestResult(fault.assetId, fault.faultId, testId, buttonData.value === 0 ? null : buttonData.value, external, action.learningLoopTable, buttonData.learningLoopTestResult)
                .then(() => this.actionResultSubmitCallback(action)).catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                });
        } else {
            this.props.FaultActions.submitCorrectiveActionResult(fault.assetId, fault.faultId, action.id, buttonData.value, external)
                .then(() => this.actionResultSubmitCallback(action)).catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                });
        }
    }

    buttonClicked(action) {
        const {intl, fault, userProfile} = this.props
        const comment = this.state.notExistingCaComment === "" ?
            this.state.allCasNames[this.state.selectedOtherCaName].name : this.state.notExistingCaComment
        this.props.FaultActions.setFaultState(fault.assetId, fault.faultId, FAULT_STATES.VERIFICATION, [],
            intl.formatMessage({id: "fault.troubleshoot.summary.info.additionalAction"}) + ": " + comment,
            userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY))
                .then(() => this.actionResultSubmitCallback(action))
                .catch(ex => verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut));
    }

    actionResultSubmitCallback(action) {
        this.fetchActionsData()
        this.closeRow(action)
        this.props.nextButtonClick()
        if (action.type === ACTION_TYPES.TEST) {
            this.setState({selectedOtherTestName: null})
        }
        // If new test/ca was performed we must update list of possible other tests and actions
        if (action.id === EXISTING_ACTION_ID) {
            this.fetchAllNamesExceptAllocated(action.type)
        }
    }

    expandFirstRowAndCollapseOthers() {
        const {fault} = this.props

        if (!fault.readOnly && fault.actions) {
            if (this.state.UIconfig_TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED) {
                const testActions = fault.actions.filter(a => this.filterActions(a, false) && a.benefit > 0 && a.type === ACTION_TYPES.TEST)
                const caActions = fault.actions.filter(a => this.filterActions(a, false) && a.benefit > 0 && a.type === ACTION_TYPES.CORRECTIVE_ACTION)

                this.expandCollapseRows(testActions, fault)
                this.expandCollapseRows(caActions, fault)
            } else {
                const actions = fault.actions.filter(a => this.filterActions(a, false) && a.benefit > 0)
                this.expandCollapseRows(actions, fault)
            }
        }
    }

    renderCloseWithAction() {
        const {intl} = this.props

        const options = this.state.allCasNames.map(ca => { return {value: ca.id, text: ca.name}})
        options.push({value: NEW_ACTION_ID, text: intl.formatMessage({id: "fault.troubleshoot.action.task.ca.new"})})

        return (
            <Modal id="close-with-action" closeIcon={false} onClose={() => this.setState({showCloseWithAction: false})}
                   open={this.state.showCloseWithAction}
                   closeOnDimmerClick={true} className="closed-modal"
            >
                <Modal.Header>
                    <FormattedMessage id="fault.close.existing"/>
                </Modal.Header>
                <Modal.Content>
                    <Select
                        label={intl.formatMessage({id: "fault.troubleshoot.action.task.ca.close"})}
                        closeOnChange={true}
                        fluid={true}
                        multiple={false}
                        placeholder={intl.formatMessage({id: "fault.detail.action.close.comment.select"}) + " "}
                        search={true}
                        options={options}
                        value={this.state.selectedOtherCaName}
                        onChange={(selectedOption) => {
                            if (selectedOption === NEW_ACTION_ID) {
                                this.setState({selectedOtherCaName: selectedOption, details: {}})
                            } else {
                                this.setState({selectedOtherCaName: selectedOption})
                            }
                        }}
                        style={{textTransform: 'none'}}/>
                    {this.state.selectedOtherCaName &&
                    <div className="other-ca-details">
                        {this.getActionDetail()}
                    </div>
                    }

                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.cancel"})}
                                onClick={() => this.setState({showCloseWithAction: false})} size="medium" type="secondary"/>
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.troubleshoot.action.ca.button"})}
                                disabled={this.state.selectedOtherCaName === null}
                                onClick={() => {
                                    this.setState({showCloseWithAction: false})
                                    this.buttonClicked({type: ACTION_TYPES.CORRECTIVE_ACTION, id: this.state.selectedOtherCaName})
                                }}
                                size="medium" type="primary"/>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }

    openReference(ref) {
        this.state.apiPoint.fetchTechPubDocument(this.props.fault.assetId, ref.link.techPubId).then(
            (response) => {
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                response.blob().then(b => {
                    const fileURL = URL.createObjectURL(b)
                    a.href = fileURL
                    a.download = ref.name
                    a.target = "_blank"
                    a.click()
                    URL.revokeObjectURL(fileURL)
                    a.remove()
                })
            }
        ).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    getListLinkItems(list) {
        if (list.length === 0) {
            return <span><FormattedMessage id="fault.troubleshoot.action.detail.noreferences"/></span>
        }
        return <ul>{list.map(s => <li key={s.link.techPubId}> {
            s.available ? <Button type="link" content={s.title.length > 0 ? s.title :
                    (<FormattedMessage id="fault.troubleshoot.action.detail.refs.titleUndefined"/>)}
                                  onClick={() => this.openReference(s)}/> :
                <span>{s.title.length > 0 ? s.title : (<FormattedMessage id="fault.troubleshoot.action.detail.refs.titleUndefined"/>)} ({s.name})</span>}
        </li>)}</ul>
    }

    getTaskTips(taskTips) {
        return taskTips.map(t => <List.Content key={t.id}>{t.text}</List.Content>)
    }

    getActionDetail() {
        const {intl} = this.props
        const descriptionDisabled =
            this.state.detail.description === "" ||
            this.state.detail.description == null ||
            this.state.detail.description === ''
                ?
                'description-disabled'
                :
                'description';
        const referenceDisabled = this.state.detail.references.length <= 0 ? 'references-disabled' : 'references';
        const validateDisabled = 'validate-disabled';
        const taskTipDisabled = this.state.detail.taskTips.length <= 0 ? 'taskTips-disabled' : 'taskTips';
        const causesDisable = this.state.detail.failureModes.length <= 0 ? 'causes-disabled' : 'causes';

        if (this.state.selectedOtherCaName === NEW_ACTION_ID) {
            return (
                <Input
                    className="full-input"
                    label={intl.formatMessage({id: `fault.troubleshoot.action.ca`})}
                    onChange={(value) => this.setState({notExistingCaComment: value})}
                />
            )
        }

        return (
            <React.Fragment>
                <h5><FormattedMessage id="fault.troubleshoot.action.detail.ca"/></h5>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <div className={descriptionDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.desc"/></h5>
                                {this.state.detail.description === '' || this.state.detail.description == null ?
                                    <FormattedMessage id="fault.troubleshoot.action.detail.desc.notAvailable"/>
                                    :
                                    <div className="description-div"
                                         dangerouslySetInnerHTML={{__html: this.state.detail.description}}/>
                                }
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} sWidth={12}>
                            <div className={referenceDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.refs"/></h5>
                                {this.getListLinkItems(this.state.detail.references)}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Divider fitted/>
                    {
                        this.props.showCauses ?
                            <Grid.Row>
                                <Grid.Column width={8} sWidth={12}>
                                    <div className={causesDisable}>
                                        <h5><FormattedMessage id="fault.troubleshoot.action.detail.causes"/></h5>
                                        <div>{this.state.detail.failureModes.map((item, id) =>
                                            <p key={id}>{item.name}</p>)}</div>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            :
                            ''
                    }
                    <Divider fitted/>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <div className={validateDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.validate"/></h5>
                                <FormattedMessage id="fault.troubleshoot.action.detail.validate.notAvailable"/>
                            </div>
                        </Grid.Column>
                        <Grid.Column width={8} sWidth={12}>
                            <div className={taskTipDisabled}>
                                <h5><FormattedMessage id="fault.troubleshoot.action.detail.tasktips"/></h5>
                                {this.state.detail.taskTips.length <= 0 ?
                                    <FormattedMessage id="fault.troubleshoot.action.detail.tasktips.noAvailable"/>
                                    :
                                    <List divided={true}>
                                        {this.getTaskTips(this.state.detail.taskTips)}
                                    </List>
                                }
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }


    expandCollapseRows(actions, fault) {
        actions.filter(a => fault.actionFilter.indexOf(ACTION_TYPES[a.type]) >= 0).map((a, i) => {
                // Expand first row unless it is already expanded
                if (i === 0 && this.state.expandedRows.indexOf(a.type + '-' + a.id) === -1) {
                    this.toggleRow(a.type + '-' + a.id)
                }
                // Collapse other rows when already expanded
                else if (i > 0 && this.state.expandedRows.indexOf(a.type + '-' + a.id) >= 0) {
                    this.toggleRow(a.type + '-' + a.id)
                } else {
                    // do not expand any row
                }
            }
        )
    }

    getTodoRows(actions, disabled) {
        const doneRowsIds = this.props.fault.actions.filter(a => this.filterActions(a, true)).map(doneRow => doneRow.id.toString());

        return actions.filter(action => this.props.fault.actionFilter.indexOf(ACTION_TYPES[action.type]) >= 0).map((action, actionIndex) => {
            const rowKey = action.type + '-' + action.id
            const isTest = action.type === ACTION_TYPES.TEST;

            // Filter options for the select component, discard those that are already present
            let allOptions = null
            if (action.id === EXISTING_ACTION_ID) {
                allOptions = (isTest ? this.state.allTestNames : this.state.allCasNames)
                    .filter(a => !doneRowsIds.includes(a.id))
                    .map((a, i) => {
                        return {value: i, text: a.name, id: a.id}
                    })
            }

            return <ActionRow
                        key={rowKey}
                        action={action}
                        doneRowsIds={doneRowsIds}
                        disabled={disabled}
                        toggleRow={this.toggleRow}
                        expandedRows={this.state.expandedRows}
                        selectedOption={isTest ? this.state.selectedOtherTestName : this.state.selectedOtherCaName}
                        options={allOptions}
                        onSelectorChange={(value) => isTest ? this.setState({selectedOtherTestName: value}) : this.setState({selectedOtherCaName: value})}
                        showCauses={this.state.UIconfig_SHOW_CAUSES_IN_CA_ACTION_DETAIL}
                        nextStep={this.props.nextButtonClick}
                        onResultSelected={this.actionResultSet}
                        notExistingComment={isTest ? this.state.notExistingTestComment : this.state.notExistingCaComment }
                        setNotExistingName={(value) => isTest ? this.setState({notExistingTestComment: value}) : this.setState({notExistingCaComment: value})}
                        onButtonClick={this.buttonClicked}
                        fetchNewData={this.fetchActionsData}
                        fetchNewOptions={this.fetchAllNamesExceptAllocated}
                        actionIndex={actionIndex}
                        setLoading={() => this.setState({loading: true})}
            />
        })

    }

    toggleRow(key) {
        this.setState((state) => {
            const rows = [...state.expandedRows]
            if (rows.indexOf(key) >= 0) {
                rows.splice(rows.indexOf(key), 1)
            } else {
                rows.push(key)
            }
            return {...state, expandedRows: rows}
        })
    }

    closeRow(action) {
        const key = action.type + '-' + action.id
        const rows = [...this.state.expandedRows]
        if (rows.indexOf(key) >= 0) {
            rows.splice(rows.indexOf(key), 1)
        }
        this.setState({expandedRows: rows})
    }

    renderFooterButtonPanel() {
        const {intl} = this.props
        return (
            <div className="button-panel">
                <Button content={intl.formatMessage({id: "fault.troubleshoot.button.back"})}
                        icon="caret-left" iconPosition="left"
                        onClick={this.props.previousButtonClick}/>
                <Button content={intl.formatMessage({id: "fault.troubleshoot.button.next"})}
                        icon="caret-right" iconPosition="right"
                        disabled={this.props.fault.actions.filter(a => a.type === ACTION_TYPES.CORRECTIVE_ACTION && a.currentResult === CORRECTIVE_ACTION_STATE.NOT_PERFORMED).length !== 0}
                        onClick={this.props.showCloseActionModal}/>
            </div>
        )
    }

    filterActions(action, done){
        if (action.type === ACTION_TYPES.TEST) {
            return done ? action.currentResult != null : action.currentResult == null
        } else {
            return done ? action.currentResult !== CORRECTIVE_ACTION_STATE.NOT_PERFORMED : action.currentResult === CORRECTIVE_ACTION_STATE.NOT_PERFORMED
        }
    }

    renderSeparately(depletedCAsMessage, depletedTestsMessage, hdaSorryNotification, testActions, caActions) {
        const {fault} = this.props

        const todoRowsTests = this.getTodoRows(testActions, fault.readOnly);
        const todoRowsCorrectiveActions = this.getTodoRows(caActions, fault.readOnly);

        const todoTest = this.renderTodoRows(depletedTestsMessage, todoRowsTests, "todoTest", "tests", todoRowsTests.length > 0 || hdaSorryNotification != null)
        const todoCAs = this.renderTodoRows(depletedCAsMessage, todoRowsCorrectiveActions, "todoCorrectiveActions", "cas", true)

        return (
            <div>
                {todoTest}
                {todoCAs}
            </div>
        )
    }

    /**
     * Renders rows of actions for To Do and New Actions section.
     * Also used in the function RenderSeparately for Tests and Corrective Actions
     * @param depletedMessage
     * @param todoRows rows to render
     * @param titleAppendix string appendix that is used for section title translation. Different for each section
     * @param showMoreAppendix string appendix that is used for button that renders more actions
     * @param expanded boolean condition that tells if the section is expanded
     */
    renderTodoRows(depletedMessage, todoRows, titleAppendix, showMoreAppendix, expanded) {
        const {intl} = this.props;
        const allCount = todoRows.length;

        let limit;
        if (showMoreAppendix === 'tests') {
            limit = this.state.shownTestsMax;
        } else if (showMoreAppendix === 'cas') {
            limit = this.state.shownCasMax;
        } else {
            limit = this.state.shownAllMax;
        }

        todoRows = todoRows.slice(0, limit);

        const titleTranslationId = "fault.troubleshoot.table." + titleAppendix;
        const showMoreTranslationId = "fault.showMore." + showMoreAppendix;

        return (
            <ExpandablePanel
                title={intl.formatMessage({id: titleTranslationId}, {count: allCount})}
                expanded={expanded}
                showButton={showMoreAppendix === 'cas'}
                performAction={() => this.setState({showCloseWithAction: true})}
            >
                {allCount === 0 ?
                    (depletedMessage !== null ?
                        <div>{depletedMessage}</div>
                        :
                        <FormattedMessage id={"fault.troubleshoot.table.empty." + showMoreAppendix}/>
                    )
                    :
                    <div>
                        {depletedMessage}
                        <React.Fragment>
                            <Table className="unstackable">
                                <Table.Header className="expandable-panel-actions">
                                    <Table.HeaderCell className="icon-cell"/>
                                    {showMoreAppendix === "tests" &&
                                        <Table.HeaderCell
                                            content={intl.formatMessage({id: "fault.troubleshoot.table.header.benefit"})}
                                            className="progress-cell"/>
                                    }
                                    {showMoreAppendix === "cas" &&
                                        <Table.HeaderCell
                                            content={intl.formatMessage({id: "fault.troubleshoot.table.header.likelihood"})}
                                            className="progress-cell"/>
                                    }
                                    <Table.HeaderCell
                                        content={intl.formatMessage({id: "fault.troubleshoot.table.header.task"})}
                                        className="computer only wide-cell"/>
                                    <Table.HeaderCell className="progress-cell"
                                                      content="Result"/>
                                    <Table.HeaderCell className="icon-cell"/>
                                </Table.Header>
                                <Table.Body>
                                    {todoRows}
                                </Table.Body>
                            </Table>
                            {limit < allCount ?
                                <div className="more-actions-button">
                                    <Button type="secondary"
                                            onClick={() => {
                                                if (showMoreAppendix === 'tests') {
                                                    this.setState({shownTestsMax: this.state.shownTestsMax + this.state.increaseShownBy})
                                                } else if (showMoreAppendix === 'cas') {
                                                    this.setState({shownCasMax: this.state.shownCasMax + this.state.increaseShownBy})
                                                } else {
                                                    this.setState({shownAllMax: this.state.shownAllMax + this.state.increaseShownBy})
                                                }
                                            }}>
                                        {<FormattedMessage id={showMoreTranslationId}/>}
                                    </Button>
                                </div>
                                :
                                null
                            }
                        </React.Fragment>
                    </div>
                }
            </ExpandablePanel>
        )
    }

    /**
     * This function renders the troubleshooting section for adding custom test or selecting one of the existing tests.
     */
    renderNewTests(depletedCAsMessage, testActions, caActions) {
        const {intl, fault} = this.props

        // Create blank test, so we can later replace it for the other test row and keep color order.
        const selectExistingTest =  {id: EXISTING_ACTION_ID, benefit: 0, likelihood: -1, name: intl.formatMessage({id: "fault.troubleshoot.action.task.test.existing"}),
            rankOrder: 0, currentResult: null, testResults: [], type: ACTION_TYPES.TEST, learningLoopTable: false}
        const newTest =             {id: NEW_ACTION_ID,      benefit: 0, likelihood: -1, name: intl.formatMessage({id: "fault.troubleshoot.action.task.test.new"}),
            rankOrder: 0, currentResult: null, testResults: [], type: ACTION_TYPES.TEST, learningLoopTable: false}
        const selectExistingCa =    {id: EXISTING_ACTION_ID, benefit: 0, likelihood: 0, name: intl.formatMessage({id: "fault.troubleshoot.action.task.ca.existing"}),
            rankOrder: 0, currentResult: null, testResults: [], type: ACTION_TYPES.CORRECTIVE_ACTION, learningLoopTable: false}
        const newCa =               {id: NEW_ACTION_ID,      benefit: 0, likelihood: 0, name: intl.formatMessage({id: "fault.troubleshoot.action.task.ca.new"}),
            rankOrder: 0, currentResult: null, testResults: [], type: ACTION_TYPES.CORRECTIVE_ACTION, learningLoopTable: false}

        const todoRows = this.getTodoRows(testActions.concat(selectExistingTest, newTest, caActions, selectExistingCa, newCa), fault.readOnly)

        return this.renderTodoRows(depletedCAsMessage, todoRows, "newActions", "all", true);
    }

    render() {
        const {fault} = this.props

        if (fault.actions === null) {
            return null
        }

        const testActions = fault.actions.filter(a => (a.benefit > 0 || a.learningLoopTable || a.currentResult !== null) && a.type === ACTION_TYPES.TEST)

        // Place CAs with greater benefit first, if all CAs benefits are 0, sort Not Performed first
        let caActions = fault.actions
            .filter(a => (a.benefit > 0 || a.currentResult !== null) && a.type === ACTION_TYPES.CORRECTIVE_ACTION)
            .sort((a, b) => {
                if (a.benefit > b.benefit) {
                    return -1
                }
                if (a.currentResult === CORRECTIVE_ACTION_STATE.NOT_PERFORMED && b.currentResult === CORRECTIVE_ACTION_STATE.NOT_PERFORMED) {
                    return 0
                } else if (a.currentResult === CORRECTIVE_ACTION_STATE.NOT_PERFORMED) {
                    return -1
                } else {
                    return 1
                }
            })

        // For HDA, if there is no tests and only 1 CA has positive likelihood, is requirement to show all not performed CA with benefit increased from 0 to 1
        if (testActions.length === 0 && caActions.length === 1 && this.state.UIconfig_ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD) {
            caActions = fault.actions.filter(a => a.type === ACTION_TYPES.CORRECTIVE_ACTION)
        }

        // HDA sorry notification block
        let hdaSorryNotification = null;
        if (testActions.length === 0 && caActions.length === 0 && this.state.UIconfig_WE_ARE_SORRY_MESSAGE) {
            hdaSorryNotification =
                <Notification
                    hasIcon={true}
                    severity="important">
                    <FormattedMessage id="fault.detail.troubleshooting.weAreSorry"/>
                </Notification>
        }

        //When there are no Corrective Actions To Do show error message
        const casDepleted = fault.actions.filter(a => this.filterActions(a, false) && a.type === ACTION_TYPES.CORRECTIVE_ACTION).length === 0
        let depletedCAsMessage;
        if (casDepleted && !isClosedState(fault.details.faultConditionState)) {
            depletedCAsMessage =
                <Notification
                    hasIcon={true}
                    severity="critical">
                    <FormattedMessage id="fault.detail.troubleshooting.depletedCAs"/>
                </Notification>
        }

        //When there are no Tests To Do show error message
        const testsDepleted = fault.actions.filter(a => a.type === ACTION_TYPES.TEST).length === 0
        let depletedTestsMessage;
        if (testsDepleted && !isClosedState(fault.details.faultConditionState)) {
            depletedTestsMessage =
                <Notification
                    hasIcon={true}
                    severity="critical">
                    <FormattedMessage id="fault.detail.troubleshooting.depletedTests"/>
                </Notification>
        }

        return (
            <div>
                <div id="actions-step">
                    {hdaSorryNotification}
                    <CloseFaultModal
                        closeModalWindow={() => this.setState({closeModalOpen: false})}
                        closeModalOpen={this.state.closeModalOpen}
                        reloadFaultCondition={() => this.props.reloadFaultCondition()}
                        troubleshootingNavigation={() => this.props.troubleshootingNavigation()}
                    />
                    {this.state.showCloseWithAction && this.renderCloseWithAction()}

                    {this.renderSeparately(depletedCAsMessage, depletedTestsMessage, hdaSorryNotification, testActions.filter(ta => !ta.learningLoopTable), caActions.filter(ca => !ca.learningLoopTable))}
                    <Loader loading={this.state.loading}/>

                    {/*{this.renderNewTests(depletedCAsMessage, testActions.filter(ta => ta.learningLoopTable), caActions.filter(ca => ca.learningLoopTable))}*/}

                </div>
                {this.renderFooterButtonPanel()}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Actions)))